// extracted by mini-css-extract-plugin
module.exports = {"imprintContainer":"Imprint_imprintContainer__11LfL"};